import { DateTime, Duration } from 'luxon';
import { GeneralLedgerAccount } from '../accounting/accounting';
import { Admin } from '../admin/admin';
import { AvailabilityParsers } from '../availability/availability-parsers';
import { AdminCommission, ProductUnitsReportRow, ScheduledReport, ScheduledReportJson } from './report';

export namespace ReportParsers {
  export class ProductUnitsReportRowJson {
    unitNumber!: string;
    serialNumber!: string;
    productName!: string;
    categories!: string[];
    locationName!: string;
    currentScheduled!: {
      currentStatus: 'Available' | 'On Rent' | 'Hard Down' | 'Soft Down' | 'Outage' | 'Sold';
      currentEvent?: AvailabilityParsers.ScheduleEntryJson;
    };
    nextScheduled!: AvailabilityParsers.ScheduleEntryJson;
    isActive!: boolean;
  }

  export function toProductUnitsReportRow(input: ProductUnitsReportRowJson): ProductUnitsReportRow {
    return {
      ...input,
      currentScheduled: {
        currentStatus: input.currentScheduled?.currentStatus,
        currentEvent: input.currentScheduled?.currentEvent
          ? AvailabilityParsers.toScheduleEntry(input.currentScheduled.currentEvent)
          : undefined,
      },
      nextScheduled: input.nextScheduled ? AvailabilityParsers.toScheduleEntry(input.nextScheduled) : undefined,
    };
  }

  export class GeneralLedgerCommissionTotalJson {
    adminId!: number;
    rate!: number;
    generalLedgerAccountTotal!: number;
    commissionTotal!: number;
    generalLedgerAccount!: GeneralLedgerAccount;
  }
  export class AdminCommissionJson {
    subtotal!: number;
    commissionTotal!: number;
    admin!: Admin;
    startDate!: string;
    endDate!: string;
    generalLedgerTotals!: GeneralLedgerCommissionTotalJson[];
    invoiceIds!: string[];
  }

  export function toAdminCommission(input: AdminCommissionJson): AdminCommission {
    return {
      ...input,
      startDate: DateTime.fromISO(input.startDate),
      endDate: DateTime.fromISO(input.endDate),
    };
  }

  export function toScheduledReport(input: ScheduledReportJson): ScheduledReport {
    return {
      ...input,
      deliveryInterval: Duration.fromISO(input.deliveryInterval),
      createdAt: DateTime.fromISO(input.createdAt),
      deletedAt: input.deletedAt ? DateTime.fromISO(input.deletedAt) : undefined,
    };
  }
}
